import type { QuantityDiscount } from '@/entities/product';
import { discountRules } from './discountConfig';
import type { DiscountRule, DiscountThreshold } from './discountConfig';

const getDiscountPercent = (
  productSlug: string,
  quantity: number,
  productDiscounts?: QuantityDiscount[],
): number => {
  if (productDiscounts && productDiscounts.length > 0) {
    const applicable = productDiscounts
      .filter((d) => quantity >= d.minQuantity)
      .sort((a, b) => b.minQuantity - a.minQuantity);

    return applicable.length > 0 ? applicable[0]!.discountPercent : 0;
  }

  return 0;
};

const getDiscountPrice = (
  productSlug: string,
  quantity: number,
  productDiscounts?: QuantityDiscount[],
): number => {
  if (productDiscounts && productDiscounts.length > 0) {
    const applicable = productDiscounts
      .filter((d) => quantity >= d.minQuantity)
      .sort((a, b) => b.minQuantity - a.minQuantity);

    return applicable.length > 0 && applicable[0]!.discountPrice ? applicable[0]!.discountPrice : 0;
  }

  return 0;
};

const getDiscountDetails = (
  productSlug: string,
  quantity: number,
  rules: DiscountRule[] = discountRules,
): { discountPercent: number; rule?: DiscountRule; threshold?: DiscountThreshold } => {
  const applicableRules = rules.filter(
    (rule) => rule.productSlugs.includes('*') || rule.productSlugs.includes(productSlug),
  );

  for (const rule of applicableRules) {
    const applicableThresholds = rule.thresholds
      .filter((threshold) => quantity >= threshold.minQuantity)
      .sort((a, b) => b.minQuantity - a.minQuantity);

    if (applicableThresholds.length > 0) {
      return {
        discountPercent: applicableThresholds[0]!.discountPercent,
        rule,
        threshold: applicableThresholds[0],
      };
    }
  }

  return { discountPercent: 0 };
};

export { getDiscountPercent, getDiscountDetails, getDiscountPrice };
